import React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "../styles/infoBarSelection.scss";

const formatSelections = (selections, options) => {
  if (selections.length === 1)
    return options.find((e) => e.id === selections[0])?.name;
  else return `${selections.length} Selected`;
};

const InfoBarSelection = ({
  isActive,
  item,
  values,
  type,
  isRequired = false,
  showExpandIndicator = false,
  isExpanded = false,
}) => {
  // console.log(values);
  return (
    <div
      className="info-bar-selection-container"
      style={{
        opacity: isActive ? 1 : 0.56,
      }}
    >
      <div className="info-bar-selection-container-inner">
        {item.icon && <img src={item.icon} alt="icon" />}
        <div className="info-select">
          <p
            className={
              values.length > 0 ? "label-select small" : "label-select"
            }
          >
            {item.label}
            {isRequired ? <b> *</b> : ""}
          </p>
          {values.length > 0 && (
            <p className="selection">
              {type && type === "date"
                ? values[0]
                : formatSelections(values, item.options)}
            </p>
          )}
        </div>
      </div>
      {showExpandIndicator && (
        <KeyboardArrowDownIcon
          style={{
            marginLeft: "8px",
            color: "#362B73",
            transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      )}
    </div>
  );
};

export default InfoBarSelection;
